import { useState } from 'react';
import { useLocation } from 'react-router-dom';

const useUsername = ({ prefillUser, userProfile }) => {
    const location = useLocation();
    const initialUsername = [prefillUser, userProfile, location.state].find(
        (user) => user?.username,
    );
    const [username, setUsername] = useState(initialUsername?.username || '');

    return [username, setUsername];
};

export default useUsername;
